<script setup lang="ts">
import type { Locales, LocalizableString } from '@/services/types/api.types';
import LiteYouTubeEmbed from 'vue-lite-youtube-embed';
import { vueVimeoPlayer } from 'vue-vimeo-player';
import { getTranslation } from '@/composables/data-display-utils';

// PROPS
const props = defineProps<{
  type: string;
  title: LocalizableString;
  videoId: string | null;
  languageEnabled: Locales[];
}>();
</script>
<template>
  <div class="video-player" v-if="!!props.videoId">
    <div v-if="props.type === 'Youtube'">
      <LiteYouTubeEmbed :id="props.videoId" :title="getTranslation(props, 'title', props.languageEnabled)" />
    </div>
    <div v-else>
      <vue-vimeo-player ref="player" :video-id="props.videoId" player-height="400" />
    </div>
  </div>
</template>
